import { SectionData, Website } from '@betterfunnel/types';
import { useCallback, useContext, useEffect, useState } from 'react';
import { DashboardContext } from '../../contexts/DashboardContext';
import {
  WebsiteUpdate,
  WebsiteUpdaterContext,
} from '../../contexts/WebsiteUpdaterContext';
import { capitalize, sendMessageToIframe } from '../../utils';
import SettingSectionTitle from '../settings/SettingSectionTitle';
import SortableList from '../SortableList';

interface Props {
  websiteId: string;
  website?: Website;
  onUpdateWebsiteEvent: (_: WebsiteUpdate) => void;
}

export default function ManageWebsiteContent({
  websiteId,
  website,
  onUpdateWebsiteEvent,
}: Props) {
  const { selectedDynamicPage } = useContext(DashboardContext);

  const { createWebsiteUpdate } = useContext(WebsiteUpdaterContext);

  const [sections, setSections] = useState<SectionData[]>(
    website?.development?.sections ?? [],
  );

  useEffect(() => {
    if (!website) return;

    const sections = website?.development?.sections;

    setSections(sections ?? []);
  }, [website]);

  const onOrderChange = useCallback(
    (items: SectionData[]) => {
      if (!selectedDynamicPage) return;

      const wu = createWebsiteUpdate(
        selectedDynamicPage.id,
        websiteId,
        '',
        '',
        items.map((item) => ({ id: item.id })),
        'reorderSections',
        [],
        website?.development
          ? JSON.parse(JSON.stringify(website?.development))
          : undefined,
      );

      if (!wu) return;

      setSections(items);
      onUpdateWebsiteEvent(wu);
    },
    [
      selectedDynamicPage,
      createWebsiteUpdate,
      websiteId,
      website?.development,
      onUpdateWebsiteEvent,
    ],
  );

  const onItemClick = useCallback(
    (section: SectionData) => {
      sendMessageToIframe({
        eventName: 'jumpTo',
        selector: `#section-${section.type}-${section.id}`,
      });

      if (!selectedDynamicPage) return;
      const wu = createWebsiteUpdate(
        selectedDynamicPage.id,
        websiteId,
        section.id,
        '',
        section,
        'editSection',
        [],
        website?.development
          ? JSON.parse(JSON.stringify(website?.development))
          : undefined,
      );

      if (!wu) return;

      onUpdateWebsiteEvent(wu);
    },
    [
      selectedDynamicPage,
      createWebsiteUpdate,
      websiteId,
      website?.development,
      onUpdateWebsiteEvent,
    ],
  );

  return (
    <div>
      <SettingSectionTitle
        title="Sections"
        // description="Add custom code to all of your landing pages."
      />
      <div className="mt-2"></div>
      <SortableList
        items={sections ?? []}
        itemClassName={'py-2 px-0 hover:bg-gray-50 cursor-pointer'}
        renderItemContent={(section) => {
          return (
            <div
              className="flex w-full flex-row justify-between gap-2 px-2"
              onClick={() => onItemClick(section)}
            >
              <span>{capitalize(section.type)}</span>
            </div>
          );
        }}
        onChange={onOrderChange}
      />
    </div>
  );
}
